import { Box, Flex,Icon } from "@chakra-ui/react";
import {MdEmail} from "react-icons/md"
import {FaLinkedinIn} from "react-icons/fa"
import {AiFillGithub} from "react-icons/ai"
import {MdCall} from "react-icons/md"
import {ImLocation} from "react-icons/im"
import { AiOutlineDownload } from "react-icons/ai";
import Heading from "./Heading";
import Text from "./Text";
import { Tokens } from "../mirrorful/theme";
import { wrap } from "framer-motion";

import { useEffect } from "react";
import Button from "./Button";


export default function About({id,classprops}){

    const handleResumeClick = () => {
        const fileName = 'Abhishree_Tripathi_Resume.pdf';
        const fileUrl = process.env.PUBLIC_URL + '/' + fileName;
        const googleDriveLink = 'https://drive.google.com/file/d/1ojIBVdUUGlA73t4zRkAyRWCSgd7HAbAu/view?usp=sharing';
    
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileName;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.id='resume-link-2'
        // link.click();
        link.dispatchEvent(new MouseEvent('click'))
        window.open(googleDriveLink, '_blank');
      };



    return (

    <Box _hover={{
        boxShadow: `0 0 20px 3px ${Tokens.blue.shades['400']}`,

      }}
      className={classprops}
      id={id}
      margin={"auto"}
      width={"60%"}
      border={ `1px solid rgba(190, 190, 190, 0.2)`}
      
      borderRadius= '40px'
      background-image= {`linear-gradient(to bottom, #030518, #05071a, #06081b, #080a1d, #090b1f, #0a0c20, #0b0d21, #0c0e22, #0d0f23, #0e1023, #0e1024, #0f1125)`}
    //   backgroundColor= {`rgba(190,190,190,0.2)`}
      backdropFilter= {`blur(10px)`}
      padding={"20px"}
    mt={10}
      >
        <Flex direction={"column"} flexWrap={wrap} gap={"5px"} alignItems={"center"}>
        <Heading   text={`About Me`}
        
        size="lg">
        </Heading>
        <Text size={"md"}  id="user-detail-intro">
            {`I'm an ambitious Full Stack Web Developer, specializing in the MERN stack. What excites me about creating software is the constant need for elegant problem-solving and potentially helping people in their daily-lives is an incredibly rewarding aspect as well. Overall, I strive to become a developer that produces simple but great-quality code.  This is why I am currently looking for my first software developer role to work in collaboration with others at a company with the same values as mine.`}
        </Text>
        <Flex mt={5} justifyContent={"center"} gap={"4px"} alignItems={"center"}>
        <Icon as={ImLocation}></Icon>
        <Text style={{ textAlign: 'center' }} size="md">
            {`Noida, UttarPradesh`}
        </Text>
        
        </Flex>
        <Flex direction={{base:"column", sm:"row",md:"row"}} justifyContent={"center"} gap={"4px"} alignItems={"center"}>
         <Icon as={MdEmail}></Icon>
        {/* <ChakraText fontSize = '18px' textAlign= 'center' size="md" id="contact-phone"> */}
        <Text style={{ textAlign: 'center' }} size="md">
           {` bhishree19@gmail.com`}
           </Text>
        {/* </ChakraText> */}
        </Flex>
        <Flex justifyContent={"center"} gap={"4px"} alignItems={"center"}>
            <Icon as={MdCall}></Icon>
        <Text style={{ textAlign: 'center' }} size="md">
            {`+91 9625352616`}
        </Text>
        
        </Flex>
        <Flex direction={"row"} gap={"4px"} justifyContent={"center"} alignItems={"center"}>
   
            <a href="https://github.com/Abhishree-codes" id="contact-github" target="_blank" rel="noopener noreferrer"> <Icon  as={AiFillGithub}></Icon></a>
        <Text style={{ textAlign: 'center' }} size="md">
            {`GitHub`}
        </Text>
        <Text>{"|"}</Text>
        <a href="https://www.linkedin.com/in/abhishree-tripathi-7b419a17a/" target="_blank" rel="noopener noreferrer" id="contact-linkedin"><Icon  as ={FaLinkedinIn}></Icon></a>
        <Text style={{ textAlign: 'center' }} size="md">
            {`LinkedIn`}
        </Text>
        </Flex>
        <Flex>
            <Button handleClick={handleResumeClick} id="resume-button-2" label="Resume" style={{ marginTop: '32px' }}>
              <Icon as={AiOutlineDownload} marginLeft={"2px"}/>
            </Button>
            
          </Flex>
        </Flex>
    </Box>
  
    )
}

//Coding caught my interest in 2021 in the middle of my Psychology degree and since then I've been working towards beginning my career as a software developer. What excites me about creating software is the constant need for elegant problem-solving and potentially helping people in their daily-lives is an incredibly rewarding aspect as well. Equally, I'm looking forward to the life-long learning that comes with it, there will always be a cool new technology to get stuck into on the horizon :) Overall, I strive to become a developer that produces simple but great-quality code.  This is why I am currently looking for my first software developer role to work in collaboration with others at a company with the same values as mine.
//            {`As an ambitious Full Stack Web Developer, I specialize in Frontend Development, aiming to empower businesses and elevate online experiences. Proficient in the MERN stack, I continuously seek opportunities to expand my knowledge and stay current with the latest technologies. By bringing a blend of creativity and technical expertise, I ensure the delivery of innovative ideas and effective solutions to every project.`}
